import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationPageConfig } from '../claim-submission.model';

@Component({
  selector: 'lib-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['./confirmation-page.component.scss'],
})
export class ConfirmationPageComponent {
  @Input() config: ConfirmationPageConfig;
  @Input() claimId: string;
  @Output() viewSubmittedClaimInformation: EventEmitter<void> =
    new EventEmitter<void>();

  viewSubmittedClaim(): void {
    this.viewSubmittedClaimInformation.emit();
  }
}
